import { useAppContext } from "../../context/AppState/AppContext";
import ErrorPage from "../../features/ErrorPage/ErrorPage";
import MainLayout from "../../layouts/MainLayout/MainLayout";
import './Error404Page.css';

const Error404Page = () => {
    const {jsonTexts} = useAppContext();
    return (
        <MainLayout overflow="hidden">
            <section className="error404Page-section">
                <ErrorPage jsonTexts={jsonTexts}/>
            </section>
        </MainLayout>
    )
}
export default Error404Page